import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Package, LogOut, User } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const nav = useNavigate();

  useEffect(() => { api.get("/orders/me").then(({ data }) => setOrders(data)).catch(() => {}); }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
        <div className="flex items-center gap-4">
          <div className="border border-ape-border p-3"><User className="text-ape-red" size={28} /></div>
          <div>
            <h1 className="font-display text-4xl tracking-tight leading-none">{user?.name?.toUpperCase()}</h1>
            <p className="font-mono2 text-xs text-ape-muted mt-1">{user?.email}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <Link to="/affiliate/dashboard" className="border border-ape-border hover:border-ape-red text-white font-head uppercase tracking-widest px-5 py-2.5 transition-colors duration-150" data-testid="account-affiliate-btn">Affiliate Dashboard</Link>
          {user?.role === "admin" && <Link to="/admin" className="border-2 border-ape-red text-ape-red hover:bg-ape-red hover:text-white font-head uppercase tracking-widest px-5 py-2.5 transition-colors duration-150" data-testid="account-admin-btn">Admin Panel</Link>}
          <button onClick={async () => { await logout(); nav("/"); }} className="border border-ape-border hover:border-ape-red text-white font-head uppercase tracking-widest px-5 py-2.5 flex items-center gap-2 transition-colors duration-150" data-testid="account-logout"><LogOut size={16} /> Logout</button>
        </div>
      </div>

      <h2 className="font-display text-2xl tracking-wide mb-5 flex items-center gap-2"><Package className="text-ape-red" size={22} /> ORDER HISTORY</h2>
      {orders.length === 0 ? (
        <div className="border border-ape-border bg-ape-surface p-10 text-center text-ape-muted">
          No orders yet. <Link to="/shop" className="text-ape-red hover:text-white transition-colors duration-150">Start shopping</Link>.
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.order_num} className="border border-ape-border bg-ape-surface p-5" data-testid={`order-${o.order_num}`}>
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="font-mono2 text-sm">{o.order_num}</div>
                <span className="font-mono2 text-[10px] tracking-widest border border-ape-red text-ape-red px-2 py-1 uppercase">{o.status.replace("_", " ")}</span>
              </div>
              <div className="mt-3 text-sm text-ape-muted">{o.items.map((i) => `${i.name} ×${i.qty}`).join(", ")}</div>
              <div className="mt-3 flex justify-between items-baseline border-t border-ape-border pt-3">
                <span className="text-xs text-ape-muted font-mono2">{new Date(o.created_at).toLocaleDateString()}</span>
                <span className="font-mono2 font-bold text-ape-red">${o.total.toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
